exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".version-index {\n  border: 1px solid #e5e5e5;\n  background: #ffffff;\n  padding: 0 30px;\n}\n.version-index-title {\n  height: 87px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.version-index-title > div {\n  display: inline-block;\n  font-size: 18px;\n  height: 34px;\n  line-height: 34px;\n}\n.version-index-title > div > div {\n  display: inline-block;\n}\n.version-index-pro {\n  padding-right: 40px;\n}\n.version-index-form {\n  float: right;\n}\n.version-index-form .ant-row:nth-child(3) {\n  margin: 0;\n}\n.version-index-form .ant-input-affix-wrapper {\n  width: auto;\n}\n.version-index-form .ant-input {\n  width: 247px;\n  height: 34px;\n}\n.version-index-form button {\n  display: inline-block;\n  margin-left: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/containers/version/index.less
// module id = 1529
// module chunks = 0